import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { LOGO } from '../constants/images';
import {
  FaBars,
  FaTimes,
  FaChevronDown,
} from 'react-icons/fa';

function Header() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const dropdownOpen = Boolean(anchorEl);

  const scrollToSection = (sectionId) => {
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setMenuOpen(false);
    setAnchorEl(null);
  };

  const handleDropdownClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDropdownClose = () => {
    setAnchorEl(null);
  };

  const handleNavigate = (path) => {
    setAnchorEl(null);
    setMenuOpen(false);
    navigate(path);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo-container">
            <img
              src={LOGO}
              alt="Mitzva Tank"
              className="logo"
              fetchPriority="high"
              decoding="async"
              width={280}
              height={216}
              onClick={() => navigate('/')}
              style={{ cursor: 'pointer' }}
            />
          </div>
          <nav className={`nav ${menuOpen ? 'nav-open' : ''}`}>
            <button className="nav-item" onClick={() => scrollToSection('inicio')}>Inicio</button>
            <button className="nav-item" onClick={() => scrollToSection('donar')}>Donar</button>
            <button className="nav-item" onClick={() => scrollToSection('mision')}>¿Quiénes somos?</button>
            <button className="nav-item" onClick={() => handleNavigate('/actividades')}>Actividades y novedades</button>
            <div className="nav-item dropdown">
              <button
                className="dropdown-toggle"
                onClick={handleDropdownClick}
                aria-controls={dropdownOpen ? 'mas-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={dropdownOpen ? 'true' : undefined}
              >
                Más <FaChevronDown className={`dropdown-icon ${dropdownOpen ? 'open' : ''}`} />
              </button>
              <Menu
                id="mas-menu"
                anchorEl={anchorEl}
                open={dropdownOpen}
                onClose={handleDropdownClose}
                MenuListProps={{
                  'aria-labelledby': 'mas-button',
                }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                sx={{
                  '& .MuiPaper-root': {
                    marginTop: '0.5rem',
                    minWidth: '240px',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                    borderRadius: '8px',
                  },
                  '& .MuiMenuItem-root': {
                    padding: '0.75rem 1.5rem',
                    fontSize: '0.95rem',
                    fontWeight: 500,
                    color: '#000000',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: '#f9fafb',
                      color: '#600002',
                      paddingLeft: '2rem',
                    },
                  },
                }}
              >
                <MenuItem onClick={() => handleNavigate('/ruta')}>
                  La Ruta
                </MenuItem>
                <MenuItem onClick={() => handleNavigate('/localidades')}>
                  Localidades Visitadas
                </MenuItem>
                <MenuItem onClick={() => handleNavigate('/festividades')}>
                  Festividades
                </MenuItem>
                <MenuItem onClick={() => handleNavigate('/mitzva-tank-mundo')}>
                  Mitzva Tank en el mundo
                </MenuItem>
                <MenuItem onClick={() => handleNavigate('/campanas')}>
                  Las 10 Campañas
                </MenuItem>
                <MenuItem onClick={() => handleNavigate('/galeria')}>
                  Galería de fotos
                </MenuItem>
              </Menu>
            </div>
          </nav>
          <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
